import { Routes } from "@angular/router";
import { ListStockTypeComponent } from "./pages/list-stock-type/list-stock-type.component";
import { CreateStockTypeComponent } from "./pages/create-stock-type/create-stock-type.component";
import { getStockTypeResolver } from "./resolvers/get-stock-type.resolver";
import { UpdateStockTypeComponent } from "./pages/update-stock-type/update-stock-type.component";
import { ViewStockTypeComponent } from "./pages/view-stock-type/view-stock-type.component";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";

export const stockTypeRoutes: Routes = [
  {
    path: "",
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.STOCK_TYPE),
    },
    children: [
      {
        path: "",
        pathMatch: "full",
        component: ListStockTypeComponent,
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.STOCK_TYPE.VIEW },
      },
      {
        path: StockTypeRoutePaths.CREATE,
        component: CreateStockTypeComponent,
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.STOCK_TYPE.CREATE },
      },
      {
        path: StockTypeRoutePaths.EDIT,
        resolve: {
          stockType: getStockTypeResolver,
        },
        component: UpdateStockTypeComponent,
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.STOCK_TYPE.UPDATE },
      },
      {
        path: StockTypeRoutePaths.VIEW,
        resolve: {
          stockType: getStockTypeResolver,
        },
        component: ViewStockTypeComponent,
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.STOCK_TYPE.VIEW },
      },
    ],
  },
];
